// This file is generated by api-generator.mjs, please do not modify it manually.

import { API_ENDPOINT, REQUEST_ORIGIN, UserRoleLevelEnum } from "@/constant/common";
import qs from "qs";
import fetchBackend from "./request";


export const getBlogList = async (params: BLOG_API.GetBlogListRequest, options?: RequestOptions): Promise<BLOG_API.GetBlogListReply | null> => {
  const requestInit: RequestInit = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      'Request-Origin': REQUEST_ORIGIN,
    },
  };
  if (options?.signal) {
    requestInit.signal = options.signal;
  }
  const roleLevel = UserRoleLevelEnum.USER_ROLE_LEVEL_IGNORE;
  const urlParams = qs.stringify(params);
  try {
    const res = await fetchBackend(`${API_ENDPOINT}blogs?${urlParams}`, requestInit, roleLevel);
    if (!res.ok) {
      return null;
    }
    const data = await res.json();
    return data;
  } catch (error) {
    return null;
  }
};

export const getRelatedBlogList = async (params: BLOG_API.GetRelatedBlogListRequest, options?: RequestOptions): Promise<BLOG_API.GetRelatedBlogListReply | null> => {
  const requestInit: RequestInit = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      'Request-Origin': REQUEST_ORIGIN,
    },
  };
  if (options?.signal) {
    requestInit.signal = options.signal;
  }
  const roleLevel = UserRoleLevelEnum.USER_ROLE_LEVEL_IGNORE;
  const urlParams = qs.stringify(params);
  try {
    const res = await fetchBackend(`${API_ENDPOINT}blogs/related-blogs?${urlParams}`, requestInit, roleLevel);
    if (!res.ok) {
      return null;
    }
    const data = await res.json();
    return data;
  } catch (error) {
    return null;
  }
};

export const getRecentBlogDate = async (params: BLOG_API.GetRecentBlogDateRequest, options?: RequestOptions): Promise<BLOG_API.GetRecentBlogDateReply | null> => {
  const requestInit: RequestInit = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      'Request-Origin': REQUEST_ORIGIN,
    },
  };
  if (options?.signal) {
    requestInit.signal = options.signal;
  }
  const roleLevel = UserRoleLevelEnum.USER_ROLE_LEVEL_IGNORE;
  const urlParams = qs.stringify(params);
  try {
    const res = await fetchBackend(`${API_ENDPOINT}blogs/recent-date?${urlParams}`, requestInit, roleLevel);
    if (!res.ok) {
      return null;
    }
    const data = await res.json();
    return data;
  } catch (error) {
    return null;
  }
};

export const getBlogCalendar = async (params: BLOG_API.GetBlogCalendarRequest, options?: RequestOptions): Promise<BLOG_API.GetBlogCalendarReply | null> => {
  const requestInit: RequestInit = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      'Request-Origin': REQUEST_ORIGIN,
    },
  };
  if (options?.signal) {
    requestInit.signal = options.signal;
  }
  const roleLevel = UserRoleLevelEnum.USER_ROLE_LEVEL_IGNORE;
  const urlParams = qs.stringify(params);
  try {
    const res = await fetchBackend(`${API_ENDPOINT}blogs/calendar?${urlParams}`, requestInit, roleLevel);
    if (!res.ok) {
      return null;
    }
    const data = await res.json();
    return data;
  } catch (error) {
    return null;
  }
};

export const getBlog = async (params: BLOG_API.GetBlogRequest, options?: RequestOptions): Promise<BLOG_API.GetBlogReply | null> => {
  const requestInit: RequestInit = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      'Request-Origin': REQUEST_ORIGIN,
    },
  };
  if (options?.signal) {
    requestInit.signal = options.signal;
  }
  const roleLevel = UserRoleLevelEnum.USER_ROLE_LEVEL_IGNORE;
  const urlParams = qs.stringify(params);
  try {
    const res = await fetchBackend(`${API_ENDPOINT}blogs/${params.url_blog_name}?${urlParams}`, requestInit, roleLevel);
    if (!res.ok) {
      return null;
    }
    const data = await res.json();
    return data;
  } catch (error) {
    return null;
  }
};

